'use strict';
var error = {
	errorFields: [],
	skipFieldList: [],
	pageErrorEvent: function () {
		var errors = [];
		var obj = {
			'event': 'LYPNError'
		};
		var pageError = {
			error_location: window.pageContext.title,
			error_type: 'Page',
			error_field: 'Not Applicable',
			error_message: $('input[name$=errorText]').val()
		}
		errors.push(pageError);

		var eObj = {errors: errors};
		$.extend(obj, eObj);
		dataLayer.push(obj);
	},
	pushErrorFieldWithDelay: function (element) {
		setTimeout(function () {
			error.pushErrorfield(element);
		}, 500);
	},
	pushErrorfield: function (element) {
		if (error.skipFieldList.indexOf(element.attr('id')) < 0 
				&& (element.hasClass('error') || element.parent().hasClass('error') || element.parents('.form-row').hasClass('error'))) {
			error.errorFields.push(element);
			error.skipFieldList.push(element.attr('id'));
		}
	},
	pushFormFieldsErrorList: function () {
		if (!this.errorFields.length) {
			return;
		}
		this.formErrorEvent(this.errorFields);
		this.errorFields = [];
	},
	pushSingleErrorObject: function ($element) {
		setTimeout(function () {
			if ($element.hasClass('error') || $element.parent().hasClass('error')) {
				var errorArr = [];
				errorArr.push($element);
				error.formErrorEvent(errorArr);
			}
		}, 500);
	},
	formErrorEventSingle: function (elementArr, $errorContainer, alternativeName) {
		// used to track gift card errors, backend errors on login, wallet
		var errors = [];
		var obj = {
			'event': 'LYPNError'
		};

		for (var i = 0; i < elementArr.length; i++) {
			var errorElement = elementArr[i];
			var pageError = {
				error_location: $(document).find('title').first().text().split('|')[0].trim(),
				error_type: 'Form',
				error_field: errorElement.parents('.form-row').find('label span:not(.required-indicator)').text() || alternativeName || 'Not Applicable',
				error_message: $errorContainer.text().trim()
			}
			errors.push(pageError);
		}

		var eObj = {errors: errors};
		$.extend(obj, eObj);
		dataLayer.push(obj);
	},
	formErrorEvent: function (formErrorsArr) {
		var errors = [];
		var obj = {
			'event': 'LYPNError'
		};
		for (var i = 0; i < formErrorsArr.length; i++) {
			var errorElement = formErrorsArr[i];
			var errorField = errorElement.parents('.form-row').find('label span:not(.required-indicator)').text()
							|| errorElement.attr('placeholder')
							|| errorElement.parents('.form-row').find('.field-label').text();
			var errorObj = {
				error_location: $(document).find('title').first().text().split('|')[0].trim(),
				error_type: 'Form',
				error_field: errorField.replace('*', '').trim() || 'Not Applicable',
				error_message: errorElement.parents('.form-row').find('.error-msg, .error-message').text()
			};
			errors.push(errorObj);
		}
		var eObj = {errors: errors};
		$.extend(obj, eObj);
		dataLayer.push(obj);
	},
	
};
module.exports = error;
